import { ColorEnum } from '@enum/style/color.enum';

import { RadioStyleType } from './radio-style.interface';

export const RadioDarkTheme: RadioStyleType = {
  colorBorder: ColorEnum.Black30,
  colorText: ColorEnum.Black100,
  colorPrimary: ColorEnum.Teal150,
  colorPrimaryActive: ColorEnum.Teal100,
  colorPrimaryHover: ColorEnum.Teal100,
};
